import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Payment } from '@payment/const';
import { StateUtils } from '@spartacus/core';
import { PaymentState, StateWithPayment } from '../payment-state';
import { getPaymentsValue } from './payment-list.selectors';
import { getPaymentState } from './state.selectors';

const getBindPaymentState: MemoizedSelector<StateWithPayment, StateUtils.LoaderState<string | null>> = createSelector(
  getPaymentState,
  (state: PaymentState) => state.bindPayment,
);

const getBindPaymentValue: MemoizedSelector<StateWithPayment, string | null> = createSelector(
  getBindPaymentState,
  (state: StateUtils.LoaderState<string | null>) => StateUtils.loaderValueSelector(state) || null,
);

export const getBindPaymentLoading: MemoizedSelector<StateWithPayment, boolean> = createSelector(
  getBindPaymentState,
  (state: StateUtils.LoaderState<string | null>) => StateUtils.loaderLoadingSelector(state),
);

export const getBindPayment: MemoizedSelector<StateWithPayment, Payment | null> = createSelector(
  getBindPaymentValue,
  getPaymentsValue,
  (bindingId: string | null, payments: Payment[]) =>
    payments.find((payment) => payment.bindingId === bindingId) || null,
);

export const getBindPaymentLater: MemoizedSelector<StateWithPayment, boolean> = createSelector(
  getPaymentState,
  (state: PaymentState) => state.bindPaymentLater,
);
